import { DemandBreakdownMode } from '@ebalance/proto/bffuser/v1/demand_breakdown_mode_model_pb'
import { z } from 'zod'

import { memoLength } from '~/models/memo'

/**
 * メモの上限 (前後の空白を除いた文字数)。backend が正規化と検証を持ち、ここは入力時に知らせる
 * ための事前チェック。
 */
export const BREAKDOWN_NOTE_MAX_LENGTH = 200

export const BreakdownModeFormSchema = z.object({
  mode: z.enum([
    String(DemandBreakdownMode.DIRECT),
    String(DemandBreakdownMode.BY_GROUP),
  ]),
  note: z
    .string()
    .refine(
      (value) => memoLength(value.trim()) <= BREAKDOWN_NOTE_MAX_LENGTH,
      `メモは${String(BREAKDOWN_NOTE_MAX_LENGTH)}文字以内で入力してください`,
    ),
})

export type BreakdownModeFormValues = z.infer<typeof BreakdownModeFormSchema>
